import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import routes from "../routes.js";

// components
import Sidebar from "../components/Sidebar/Sidebar.jsx";
import Navigation from "../components/Navbars/Navigation.jsx";
import Loading from '../components/Loading/Loading';

// api
import acesso_api from "../api/acesso_api.js";

// helpers
import { showMessage } from "../helpers/message.js";
import { useAuth } from "../context/auth.js";

export default function Admin() {
  const location = useLocation();
  // Controla os dados do módulo acessado
  const [moduloUtilizado, setModuloUtilizado] = useState(null);

  const { session, setupVariavel } = useAuth();

  // Controla exibiição do menu lateral
  const [openSidebar, setOpenSidebar] = useState(true);

  // Grava todas as rotas que o usuário possui acesso
  const [routesAdmin, setRoutesAdmin] = useState([]);

  // Grava todas as rotas que podem ser exibidas no menu
  const [routesSidebar, setRoutesSidebar] = useState([]);

  // Controla exibição do loading
  const [loading, setLoading] = useState(false);

  // Ícone e Nome da tela a ser exibido no navbar
  const [icon, setIcon] = useState();
  const [brand, setBrand] = useState();

  // Controle de menu e submenu aberto
  const toggle = () => setOpenSidebar(!openSidebar);

  // Carregamento da Página
  useEffect(() => {
    if (session == null)
      window.location.href = "/auth/login"
    if (session && session.expired) {
      showMessage("Aviso", "Sua sessão expirou. Realize o acesso novamente!", 'warning', function () {
        window.location.href = "/auth/login"
      });
    }
    if (session != null) {
      setLoading(true);
      const dadosModulo = {};
      dadosModulo.sigla = session.acesso.sigla;
      dadosModulo.title = session.acesso.modulo;
      if (session.acesso.acesso_descricao)
        dadosModulo.title += ": " + session.acesso.acesso_descricao;
      setModuloUtilizado(dadosModulo);
      getRoutes(dadosModulo.sigla);
    }

  }, []);

  // Mudança de Rota
  useEffect(() => {
    getIconAndBrand(routesSidebar);
  }, [location.pathname]);

  // Busca a rota ativa
  function getIconAndBrand(_routesSidebar) {
    if (_routesSidebar.length > 0) {
      _routesSidebar = _routesSidebar.map((prop, key) => {
        if (!prop.submenus && window.location.href.indexOf(prop.layout + "/" + prop.path) !== -1) {
          if (prop.icon && prop.name) {
            setIcon(prop.icon);
            setBrand(prop.name);
          }
          prop.active = true;
        } else if (prop.submenus) {
          prop.submenus.map(value => {
            if (window.location.href.indexOf(value.layout + "/" + prop.path) !== -1) {
              if (value.icon && value.name) {
                setIcon(value.icon);
                setBrand(value.name);
              }
              value.active = true;
            } else {
              value.active = false;
            }
            return value;
          })
        } else {
          prop.active = false;
        }

        return prop;
      });
      setRoutesSidebar(_routesSidebar);
    }

  }

  // Busca as rotas de acordo com a permissão de acesso do usuário
  function getRoutes(modulo) {
    setLoading(true);
    acesso_api.getFuncionalidadesAcesso(modulo).then(result => {
      let _routes = []; // Carrega as rotas de navegação interna
      let _routesSidebar = []; // Carrega os itens do menu
      
      routes.filter(f => f.layout == "/admin" ).map((prop, key) => {
        if (!prop.submenus) {
          const funcionalidade = result.data.filter(f => { return f.funcao == prop.codigoFuncionalidade});

          // substituido pelo valor que está no paramêtro 
          prop.name = prop.name.replace("MTR", setupVariavel?.siglaDocumentoColeta);
          prop.path = prop.path.replace("MTR", setupVariavel?.siglaDocumentoColeta).replace("{identificacaoDocumentoColeta}", setupVariavel?.siglaDocumentoColeta.toLowerCase())

          if (funcionalidade.length > 0 || (prop.modulo && prop.modulo.filter(m => m == session.acesso.modulo).length > 0)) {
            prop.sidebar && _routesSidebar.push(prop);
            _routes.push({
              layout: prop.layout,
              path: prop.path,
              permissao: !prop.codigoFuncionalidade || funcionalidade || prop.codigoFuncionalidade === "Relatorios" ? "Visualizar" : funcionalidade[0].permissao,
              component: prop.component,
              name: prop.name,
              icon: prop.icon
            })
          }
        }
        else {

          let _submenus = prop.submenus.filter(f => result.data.filter(y => y.funcao == f.codigoFuncionalidade).length > 0 && (!f.modulo || (f.modulo && f.modulo.indexOf(session.acesso.modulo) != -1)))
          
          if (_submenus.length > 0 && prop.sidebar) {
            let _menu = prop;
            _menu.submenus = _submenus;
            _routesSidebar.push(_menu);
          }

          prop.submenus.map((subprop, subkey) => {
            const funcionalidade = result.data.filter(f => f.funcao == subprop.codigoFuncionalidade && (!subprop.modulo || subprop.modulo.filter(m => m == session.acesso.modulo).length > 0));

            // substituido pelo valor que está no paramêtro 
            subprop.name = subprop.name.replace("MTR", setupVariavel?.siglaDocumentoColeta);

            if (funcionalidade.length > 0 || (subprop.modulo && subprop.modulo.indexOf(session.acesso.modulo) != -1)) {
              _routes.push({
                layout: prop.layout,
                path: subprop.path.replace("mtr", setupVariavel?.siglaDocumentoColeta),
                permissao: funcionalidade.length > 0 ? funcionalidade[0].permissao : "Visualizar",
                component: subprop.component,
                name: subprop.name,
                icon: subprop.icon
              })
            }
          })
        }
      })


      
      setRoutesAdmin(_routes);
      setRoutesSidebar(_routesSidebar);
      getIconAndBrand(_routesSidebar);
    }).catch(e => showMessage("Aviso", e.message, "error", null))
      .finally(f => setLoading(false));
  }

  return (
    <>
      {loading && <Loading />}
      {moduloUtilizado &&
        <div className="adminLayout d-flex flex-column">
          <div className="d-flex align-items-start justify-content-between">
            <Sidebar isOpen={openSidebar} toggle={toggle} moduloUtilizado={moduloUtilizado} routes={routesSidebar} />
            <div className={`mainAdmin ${openSidebar ? "is-open" : ""}`}>
              <Navigation
                icon={icon}
                brand={brand}
                button={true}
                toggle={toggle}
                color={"#333"}
                iconColor={"#fff"}
                userMenu
                notification={session && session.acesso && session.acesso.sigla != "GS" ? true : false}
              />
              <Routes >
                {routesAdmin.map((prop, key) => {
                  const Screen = prop.component;
                  if (prop.layout !== "/admin") {
                    return <></>;
                  } else {
                    if (prop.permissao != "Bloqueado") {
                      // queria que a url mudadasse de acordo com 'identificacaoDocumentoColeta' no path
                      return (
                        <Route
                          path={prop.path.replace("mtr", setupVariavel?.siglaDocumentoColeta)}
                          element={<Screen permissao={prop.permissao} />}
                          key={key}
                        />
                      );
                    }
                  }
                })}
              </Routes>

            </div>
          </div>
        </div>
      }
      {
        !!moduloUtilizado && moduloUtilizado.sigla != "GG" &&
        <Helmet>
          {/*Chat do movidesk*/}
          <script type="text/javascript">var mdChatClient = "44669DE5450B407493549D817C8CD97D";</script>
          <script src="https://chat.movidesk.com/Scripts/chat-widget.min.js"></script>
        </Helmet>
      }
    </>
  );
}
